import { Component, Inject, OnInit, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { InsertionPlanChoiceService } from 'src/app/collections/inspection-plan-assistant/insertion-plan-choice.service';
import { SESSION_STORAGE, StorageService, User, Util } from '@phdsoft/common';
import { IWindow } from '@phdsoft/window';
import { AutomaticPoints } from '../_models/AutomaticPoints';
import { v4 as uuidv4 } from 'uuid'
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { IAutomaticPlanTypeSelectorData } from '../automatic-plan-type-selector/automatic-plan-type-selector.component';
import { InspectionRegion } from '../_models/InspectionRegion';
import { InspectionSession } from '../_models/InspectionSession';
import { GeneralSettings } from '../_models/GeneralSettings';
import moment from 'moment';
import { AssetManager } from 'src/app/asset-manager/asset-manager';
import { AreaSettings } from '../_models/AreaSettings';
import { TemplateService } from '@app/template/template.service';
import { ISideboard } from '@app/side-board/ISideboard';


interface APAWData {
  AssetId: any,
  regions: any
  regionsIds: any
  sectionIds: any
  sectionNames: any
  automatiPlanTypeSelectorData: IAutomaticPlanTypeSelectorData
}

@Component({
  selector: 'phdsoft-automatic-plan-area-wizard',
  templateUrl: './automatic-plan-area-wizard.component.html',
  styleUrls: ['./automatic-plan-area-wizard.component.scss']
})
export class AutomaticPlanAreaWizardComponent implements OnInit, OnChanges {
  /** Where the day is in several open plans, which one the new points go to. */
  private readonly insertionPlanChoice = inject(InsertionPlanChoiceService);

  @Input() automatiPlanTypeSelectorData: IAutomaticPlanTypeSelectorData;
  
  isShown = true
  isGeneralSettingsLoaded = false
  _AutomaticPoints: AutomaticPoints;

  optionsWindow: ISideboard = {
    VisibleMini: true,
    VisibleClose: true,
    Header: {
      VisibleTitle: true,
      Title: 'Automatic - Area Positioning Wizard'
    },
    Footer: {
      Visible: true,
      ShowCancel: false,
    }
  };


  data: APAWData
  pageIndex: number = 0;

  constructor(
    private readonly storageService: StorageService,
    private http: HttpClient,
    private assetManager: AssetManager,
    private templateService: TemplateService
  ) { 
    // Move data initialization to ngOnInit or ngOnChanges
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.automatiPlanTypeSelectorData && changes.automatiPlanTypeSelectorData.currentValue) {
      // Re-initialize data when the input changes
      this.setupData();
      this.initializeData();
    }
  }

  setupData() {
    const AssedId = this.assetManager.asset.assetInfo.AssetId;
    const hasSomeChecked = this.assetManager.asset.GetStructureVisibleRegions().some(x => x.visible);

    const regions = this.assetManager.asset.GetStructureVisibleRegions().filter(x => hasSomeChecked ? x.visible :
      x.sections.some(y => y.visible && y.group.parent.visible)).map(x => {
        if (!x.Guid) return
        const hasSomeSectionChecked = x.sections.some(y => y.visible);

        return [x.Guid, x.Name, x.sections.filter(y => hasSomeSectionChecked ? y.visible : y.visible).map(y => [
          y.Guid, y.Name
        ]),
        ]
      });

    const regionsIds = this.assetManager.asset.GetStructureVisibleRegions()
      .filter((x) => x.visible)
      .flatMap((y) => y.Guid)
    const sectionIds = this.assetManager.asset.GetStructureVisibleRegions().map(y => y.sections
      .filter((x) => x.visible)
      .flatMap((x) => x.Guid))
    const sectionNames = this.assetManager.asset.GetStructureVisibleRegions().map(y => y.sections
      .filter((x) => x.visible)
      .flatMap((x) => x.Name))

    this.data = {
      AssetId: AssedId,
      regions: regions,
      regionsIds: regionsIds,
      sectionIds: sectionIds,
      sectionNames: sectionNames,
      automatiPlanTypeSelectorData: this.automatiPlanTypeSelectorData
    }
    
    console.log('Data setup complete:', this.data);
  }

  transformBack = (region) => ({
    SectionIds: region.SectionIds,
    RegionName: region.name,
    RegionId: region.id,
    RegionChecked: region.selected,
    Sections: region.children.map(x => ({ SectionName: x.name, SectionId: x.id, SectionChecked: x.selected }))
  })

  tranform = (region) => ({
    name: region.RegionName,
    id: region.RegionId,
    selected: false,
    parentId: '',
    item: '',
    children: region.Sections.map(y => ({ name: y.SectionName, parentId: region.RegionId, selected: false, id: y.SectionId }))
  })

  intializeGeneralSettings() {
    this._AutomaticPoints.GeneralSettings = new GeneralSettings();
    this._AutomaticPoints.GeneralSettings.CurrentPage = true;
    this._AutomaticPoints.GeneralSettings.AllPages = false;
    this._AutomaticPoints.GeneralSettings.BulkheadsNoStifffners = true;
    this._AutomaticPoints.GeneralSettings.DeleteOldAutomaticPoints = false;
    this._AutomaticPoints.GeneralSettings.Date = moment(this.assetManager.referenceDate).format("yyyy-MM-DD")

    this._AutomaticPoints.GeneralSettings.Regions = [];


    for (let i = 0; i <= this.data.regions.length - 1; i++) {
      let _Lst_SectionIds = [];

      var _ItemRegions = new InspectionRegion();
      _ItemRegions.RegionId = this.data.regions[i][0];
      _ItemRegions.SectionIds = this.data.regions[i][2].map(x => x[0]);
      _ItemRegions.RegionName = this.data.regions[i][1];
      _ItemRegions.RegionChecked = !Util.isNullOrUndefined(this.data.regionsIds.find(x => x === this.data.regions[i][0]));
      if (!this.isShown) {
        _ItemRegions.RegionChecked = true;
      }



      var _Info_Session = new InspectionSession();
      _ItemRegions.Sections = [];

      for (let j = 0; j <= this.data.regions[i][2].length - 1; j++) {
        const sectionInfo = {
          SectionId: this.data.regions[i][2][j][0], SectionName: this.data.regions[i][2][j][1],
          SectionChecked: !Util.isNullOrUndefined(this.data.sectionIds.find(x => x === this.data.regions[i][2][j][0]))
        }
        if (!this.isShown) {
          sectionInfo.SectionChecked = true;
        }

        _Lst_SectionIds.push(this.data.regions[i][2][j][0]);

        _ItemRegions.Sections.push(sectionInfo);
      }

      if (this.isShown) {
        this._AutomaticPoints.GeneralSettings.Regions.push(this.tranform(_ItemRegions));
      } else {
        this._AutomaticPoints.GeneralSettings.Regions.push(_ItemRegions);
      }
      this.isGeneralSettingsLoaded = true
    }
  }

  initializeAutomaticPoints() {
    this._AutomaticPoints = new AutomaticPoints();
    this._AutomaticPoints.Id = null;
    this._AutomaticPoints.AssetId = this.data.AssetId;
    this._AutomaticPoints.CollectionId = null;
    this._AutomaticPoints.Label = "AutomaticPoints";
    
    // Check if automatiPlanTypeSelectorData is available
    if (this.automatiPlanTypeSelectorData) {
      this._AutomaticPoints.CheckLists = this.automatiPlanTypeSelectorData.checkLists;
      this._AutomaticPoints.InspectionTypeId = this.automatiPlanTypeSelectorData.inspectionTypeId;
      this._AutomaticPoints.InspectionMethodId = this.automatiPlanTypeSelectorData.inspectionMethodId;
      this._AutomaticPoints.InspectionTypeName = this.automatiPlanTypeSelectorData.inspectionTypeName;
      this._AutomaticPoints.InspectionTypeAlias = this.assetManager.listInpectionType?.find(t => t.id === this.automatiPlanTypeSelectorData.inspectionTypeId)?.alias;
    } else {
      console.warn('automatiPlanTypeSelectorData is not available');
    }
  }

  initializeAreaSettings() {
    this._AutomaticPoints.AreaSettings = new AreaSettings()
    this._AutomaticPoints.AreaSettings.AreaForCriticalAreas = false;
  }

  initializeData() {
    this.initializeAutomaticPoints()
    this.intializeGeneralSettings()
    this.initializeAreaSettings()
  }

  onSelectSection({ regionId, sectionId }) {
    this._AutomaticPoints.GeneralSettings.Regions.forEach(element => {
      if (element.id === regionId) {
        element.children.forEach(s => {
          if (s.id === sectionId) {
            s.selected = !Boolean(s.selected)
          }
        })
      }
    });
  }

  onSelectRegion({ regionId }) {
    this._AutomaticPoints.GeneralSettings.Regions.forEach(element => {
      if (element.id === regionId) {
        var selected = !element.selected
        element.selected = selected
        element.children.forEach(s => {
          s.selected = selected
        });
      }
    });
  }


  async submit() {

    this._AutomaticPoints.PlatesSettings = null
    this._AutomaticPoints.StiffenersSettings = null
    this._AutomaticPoints.FacePlatesSettings = null
    this._AutomaticPoints.BracketSettings = null

    const autoPoints = JSON.parse(JSON.stringify(this._AutomaticPoints)) as AutomaticPoints;
    autoPoints.Date = this.assetManager.referenceDate;
    if (true) {
      const checkedRegions = []

      for (const region of autoPoints.GeneralSettings.Regions) {
        if (region.children.some(x => x.selected)) {
          //checkedRegions.push(this.transformBack(region));
          const checkedSections = [];
          for (const section of region.children) {
            if (section.selected) {
              checkedSections.push(section.id);
            }
          }

          region.SectionIds = checkedSections;
          checkedRegions.push(this.transformBack(region));
        }
      }
      autoPoints.GeneralSettings.Regions = checkedRegions;
    }

    const user = await this.storageService.getItem<any>(SESSION_STORAGE.USER) as User
    autoPoints.UserId = user.id
    autoPoints.CollectionId = uuidv4().replace(/-/g, '') as string;
    if (!(await this.insertionPlanChoice.prepareBotRequest(autoPoints))) return;
    let _response = await this.http.post<any>(
      environment.API_INSPEC + 'UtmPoints/signalrutmautomaticinspectionpoints',
      autoPoints
    ).toPromise();
  };

  ngOnInit(): void {
    // Only initialize if we have the data
    if (this.automatiPlanTypeSelectorData) {
      this.setupData();
      this.initializeData();
    }
  }

  back() {
    this.pageIndex--;
    if (this.pageIndex < 0) this.pageIndex = 0;
  }

  next() {
    this.pageIndex++;
    if (this.pageIndex > 1) this.pageIndex = 1; // Only 2 pages in this component
  }

  closeWindow() {
    this.templateService.toggleAutomaticPlanAreaWizard(false)
  }

}
